import {
  fetchBasedCall,
  type IHttpCall,
  type IHttpRequest,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import {
  CreateProspectRequestDto,
  CreateProspectResponseDto,
} from './create-prospect.types';

type CreateProspectOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export function createProspectService(
  baseUrl: string,
  payload: CreateProspectRequestDto,
  options?: CreateProspectOptions,
): Promise<IHttpResponse<CreateProspectResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<CreateProspectRequestDto> = {
    url: `${baseUrl}/api/v2/prospects/`,
    method: 'POST',
    headers,
    body: payload,
    schemas: {
      request: CreateProspectRequestDto,
      response: CreateProspectResponseDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
